export default __webpack_public_path__ + "static/media/appstore.08029b1e.svg";